import React, { useEffect, useState } from 'react';
import { Plus, X } from 'react-feather';
import '../../styles/cardStyles.css';
import { VaccinationsGet } from 'apiServices/reducer/apiService';
import { useDispatch, useSelector } from 'react-redux';
import VaccinationModal from '../dialogs/dashboard/addVaccination';
import ManageVaccinationModal from '../dialogs/dashboard/manageVaccination';

const VaccinationCard = ({
    showAddButton,
    onAdd,
    onRemove,
    widgetName,
    draggable = false,
    onDragStart,
    hideHeader = false,
    selectedFamilyMember
}) => {
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.apiService.login);
    const isProvider = userData.user_type_name === 'Provider';
    
    // Use selectedFamilyMember's user_id if available, otherwise use current user's ID
    const userId = selectedFamilyMember?.user_id || (isProvider ? localStorage.getItem('patientUserId') : userData.user_id);
    
    const token = useSelector((state) => state.apiService?.token);
    const [vaccinatedData, setVaccinatedData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showManageModal, setShowManageModal] = useState(false);
    const fetchVaccinationData = async () => {
        try {
            const response = await dispatch(VaccinationsGet({ UserID: userId, token }));
            if (response?.payload && Array.isArray(response.payload)) {
                setVaccinatedData(response.payload);
            } else {
                setVaccinatedData([]);
            }
        } catch (err) {
            console.error("Error fetching vaccination data:", err);
            setVaccinatedData([]);
        }
    };

    useEffect(() => {
        if (userId && token) {
            fetchVaccinationData();
        }
    }, [userId, token, selectedFamilyMember]);

    const handleAddClick = () => {
        setSelectedRow(null);
        setShowModal(true);
    };

    const handleManageClick = (row) => {
        setSelectedRow(row);
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };
    // / upcoming-widget-cardwidget allergy-card-container
    return (
        <>
            {!hideHeader ? (
                <div
                    className="cardwidget cardwidgetHeight d-flex flex-column shadow-lg shadow-sm border-0 mb-3 rounded-3"
                    draggable={draggable}
                    onDragStart={onDragStart}
                >
                    <div className="cardwidget-header cardwidgehtHeaderBG d-flex justify-content-between align-items-center px-3 py-1">
                        <h6 className="mb-0 text-capitalize">
                            {widgetName || "Vaccination / Immunization Record"}
                        </h6>
                        {showAddButton ? (
                            <button
                                className="btn btn-sm px-0"
                                onClick={onAdd}
                                title="Add to Dashboard"
                            >
                                <Plus size={15} color='black' />
                            </button>
                        ) : (
                            <button
                                className="btn btn-sm  px-0"
                                onClick={onRemove}
                                title="Remove from Dashboard"
                            >
                                <X size={15} color='black' />
                            </button>
                        )}
                    </div>
                    <div className="cardwidget-body px-3 py-2 flex-grow-1">
                        {vaccinatedData.length === 0 ? (
                            <p className="text-muted">No vaccination data available.</p>
                        ) : (
                            vaccinatedData.map((item, index) => (
                                <div key={index} className="mb-3 rounded">
                                    <div className="d-flex justify-content-between">
                                        <span className="fw-semibold">{item.vaccine_name || "N/A"}</span>
                                        <span className="text-muted small">
                                            Dose {item.dose_number || "N/A"} &nbsp;&nbsp; {item.date || "N/A"}
                                        </span>
                                    </div>
                                    <div className="text-muted small">
                                        {item.manufacturer || "N/A"}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>

                    {!isProvider &&
                        <>

                            <div className="cardwidget-footer bg-white border-top d-flex justify-content-start px-3 py-2">
                                <button
                                    className="btn btn-link modalfooterclickeventtext p-0 me-2 text-capitalize"
                                    onClick={handleAddClick}
                                >
                                    Add
                                </button>
                                <span className="text-muted">|</span>
                                <button className="btn btn-link modalfooterclickeventtext p-0 ms-2 text-capitalize" onClick={() => setShowManageModal(true)}>Manage</button>
                            </div>
                        </>
                    }
                </div>
            ) : (
                <div style={{ padding: '16px 12px' }}>
                    {vaccinatedData.length === 0 ? (
                        <p className="text-muted">No vaccination data available.</p>
                    ) : (
                        vaccinatedData.map((item, index) => (
                            <div key={index} className="mb-3">
                                <div className="d-flex justify-content-between">
                                    <span className="fw-semibold">{item.vaccine_name || "N/A"}</span>
                                    <span className="text-muted small">
                                        Dose {item.dose_number || "N/A"} &nbsp;&nbsp; {item.date || "N/A"}
                                    </span>
                                </div>
                                <div className="text-muted small">
                                    {item.manufacturer || "N/A"}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            )}

            <VaccinationModal
                show={showModal}
                handleClose={handleModalClose}
                rowData={selectedRow}
                refreshVaccinationData={fetchVaccinationData}
                userId={userId}
            />
            <ManageVaccinationModal
                show={showManageModal}
                onHide={(isDeleted) => {
                    setShowManageModal(false);
                    if (isDeleted) {
                        fetchVaccinationData();
                    }
                }}
                refreshVaccinationData={fetchVaccinationData}
                userId={userId}
            />
        </>
    );
};

export default VaccinationCard;